
import React, {useEffect, useState} from 'react';
import { message, Spin } from 'antd';

// Helper function to format file size
const humanFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

// TODO: Add these functions to employee.service.jsx
const getDocuments = async (empId) => {
  // Placeholder - implement actual API call
  return { data: [] };
};

const uploadDocument = async (formData) => {
  // Placeholder - implement actual API call
  return { success: true, message: 'Document uploaded', data: [] };
};

function Documents ({emp_id}) {
  const [selected, setSelected] = useState([]);
  const [documents, setDocuments] = useState([]);

  const fetchDocument = () => {
    getDocuments(emp_id).then(res => {
      setDocuments(res.data);
    }).catch(() => message.error('Unable to fetch documents'))
  }

  useEffect(() => {
    if (emp_id)
      fetchDocument();

  }, [emp_id])

  const doUpload = async (files) => {
    if (files.length > 5){
      message.error('You cannot upload more than 5 documents at a time');
      return false;
    }
    if (files.length) {
      const arr = Array.from(files);

      setSelected(arr);

      let formData = new FormData();
      formData.append('emp_id', emp_id);
      arr.forEach((file) => {
        formData.append('files[]', file, file.name);
      });

      await uploadDocument(formData).then(res => {
        setSelected([]);
        if (res.success) {
          message.success(res.message);
          setDocuments([...documents, ...res.data]);
        } else {
          message.error(res.message);
        }
      }).catch(() => {
        setSelected([]);
        message.error('Something went wrong');
      });
    }
  }

  const doDelete = (e, item) => {
    // TODO: Implement delete functionality with API call
    if (window.confirm('Are you sure you want to delete this document?')) {
      // Placeholder - implement actual API call to delete document
      setDocuments(documents.filter(doc => doc.id !== item.id));
      message.success('Document deleted successfully');
    }
  }

  const openDocument = (path) => {
    window.open(path, '_blank');
  }

  return (
    <div className="content container-fluid">
      <div className="row">
        <div className="col-sm-12 px-0">
          <div className="file-wrap">
            <div className="file-cont-wrap mx-0 w-100">
              <div className="file-cont-inner">
                <div className="file-cont-header">
                  <span>Document Manager</span>
                  <div className="file-options">
                    <span className="btn-file">
                      <input
                        type="file"
                        multiple
                        className="upload"
                        accept=".xls,.xlsx,.pdf,.doc,.docx,.jpeg,.jpg,.png"
                        onChange={(e) => {
                          doUpload(e.target.files);
                        }}
                      />
                      <i className="fa fa-upload" />
                    </span>
                  </div>
                </div>
                <div className="file-content">
                  <div className="file-body">
                    <div className="file-scroll">
                      <div className="file-content-inner">
                        <div className="row row-sm">
                          {selected.map((file, i) =>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3" key={`file-${i}`}>
                              <div className="card card-file">
                                <div className="card-file-thumb">
                                  <Spin />
                                </div>
                                <div className="card-body">
                                  <h6><a href="">{file.name}</a></h6>
                                  <span>{humanFileSize(file.size)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                          {documents.map(doc =>
                            <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3" key={doc.id}>
                              <div className="card card-file">
                                <div className="dropdown-file">
                                  <a href="javascript:;" className="dropdown-link" onClick={() => openDocument(doc.doc_path)}>
                                    <i className="fa fa-download" /></a>
                                  <a href="javascript:;"
                                     className="dropdown-link text-danger"
                                     onClick={(e) => doDelete(e, doc)}>
                                    <i className="fa fa-trash-o" />
                                  </a>
                                </div>
                                <div className="card-file-thumb">
                                  <i className="fa fa-file-pdf-o" />
                                </div>
                                <div className="card-body">
                                  <h6><a href="">{doc.doc_name}</a></h6>
                                  <span>{humanFileSize(doc.doc_size)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
       );
}

export default Documents;
